import { FORM_ERROR } from 'final-form';
import React from 'react';
import styled from 'styled-components';

import { patchInboundMerchant } from 'apis/merchant-onboarding-service/api';
import { Typography as T } from 'common/typography';

import { SsmoCountryConfig } from '../../SelfServeFormView/SelfServeSignUpForm/types';
import { SelfServeStepsIdentifiers } from '../constants';
import DevicePreferencesForm from '../forms/ServicePricingForm/DevicePreferencesForm';
import { DevicePreferences, DevicePreferencesSchema } from '../forms/validation';
import { InboundMerchant } from '../types';

type DeviceSelectionProps = {
  inboundMerchant: InboundMerchant;
  ssmoCountryConfig: SsmoCountryConfig;
  goToNextStep: () => void;
  setUpdateIsInProgress: (inProgress: boolean) => void;
};

const Wrapper = styled.div``;

const ContentContainer = styled.div`
  margin-block-end: 32px;
`;

const Title = styled(T.Title1)`
  display: block;
  width: 100%;
  font-weight: 700;
  margin-block-end: 16px;
`;

const DeviceSelectionStep = ({
  inboundMerchant,
  ssmoCountryConfig,
  goToNextStep,
  setUpdateIsInProgress,
}: DeviceSelectionProps) => {
  const handleDevicePreferencesSubmit = async (
    values: DevicePreferences,
  ): Promise<{
    [key: string]: string | Error;
  } | void> => {
    try {
      setUpdateIsInProgress(true);
      const validFormValues = DevicePreferencesSchema.validateSync(values);

      await patchInboundMerchant(validFormValues, inboundMerchant.merchantId);
      goToNextStep();
    } catch (submitError) {
      return { [FORM_ERROR]: submitError as Error };
    } finally {
      setUpdateIsInProgress(false);
    }
  };

  return (
    <Wrapper>
      <ContentContainer>
        <Title>Here’s how you’ll receive your orders</Title>
        <DevicePreferencesForm
          deviceConfig={ssmoCountryConfig.devicesConfig}
          devicePreferences={{
            needsPrinter: inboundMerchant!.needsPrinter || false,
            needsMobileDataPackage: inboundMerchant!.needsMobileDataPackage || false,
          }}
          handleSubmit={handleDevicePreferencesSubmit}
          formId={SelfServeStepsIdentifiers.DeviceSelection}
        />
      </ContentContainer>
    </Wrapper>
  );
};

export default DeviceSelectionStep;
